// services/userDirectoryService.ts
// Read-only lookups against the flat profiles/{profileId} index
// (Omore Phase 4 denormalization). No writes - see flatProfileGuard.ts.

import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';
import type { FlatProfileDoc } from '../types/flatProfile';

const PROFILES_COLLECTION = 'profiles';

// Highest-sorting BMP code point. Combined with a ">=" lower bound of the
// prefix itself, this turns a range query into a Firestore "starts with".
const HIGH_CODE_POINT = String.fromCharCode(0xf8ff);

/**
 * Prefix-search profiles by school name. Matches against schoolNameLower on
 * the flat index rather than lowercasing school.name at read time.
 */
export async function searchProfilesBySchool(
    schoolNameQuery: string,
    limitCount: number = 50
): Promise<FlatProfileDoc[]> {
    const prefix = schoolNameQuery.trim().toLowerCase();
    if (!prefix) return [];

    const snap = await getDocs(
        query(
            collection(db, PROFILES_COLLECTION),
            where('schoolNameLower', '>=', prefix),
            where('schoolNameLower', '<', prefix + HIGH_CODE_POINT),
            orderBy('schoolNameLower'),
            limit(limitCount)
        )
    );

    return snap.docs.map((d) => d.data() as FlatProfileDoc);
}
